import { Bar, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
	extends: Bar,
	mixins: [reactiveProp],
	props: ['options'],
	mounted() {
		this.renderChart(this.chartData, this.options);
	},

	/* this.pieChartData = {
          labels: ["Extracted", "Rejected", "Others"],
          datasets: [
              {
                  label: "One",
                  backgroundColor: "#087979",
                  data: [10, 20, 30]
              }
          ]
      }; */
};
